/**
 * Icon-only control for modal list rows (e.g. red trash).
 * Prefer this over CustomButton so list content stays the focus.
 */
export default function ListIconButton({
  children,
  className = "",
  variant = "danger",
  type = "button",
  ...rest
}) {
  const variantClass =
    variant === "muted" ? "cm-list-icon-btn--muted" : "cm-list-icon-btn--danger";
  return (
    <button
      type={type}
      className={`cm-list-icon-btn ${variantClass}${className ? ` ${className}` : ""}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
}
